import getFixedWithLocale from "./getFixedWithLocale"

const getPercentage = (value, max, fixed = 2) => {
    const perc = parseFloat(value / max * 100)

    if(false === fixed) {
        return perc
    } else {
        return getFixedWithLocale(perc, fixed)
    }
}
    

export default getPercentage


